// Small helper to pick a distinct avatar color per role.
//   • employee (default) → blue family (name-based hue in 200-240)
//   • teamlead            → green family (140-165)
//   • manager             → purple family (270-295)
//   • owner               → warm amber family (25-45)
// Within a role, the exact hue is derived from the name so two employees
// don't collide but still stay in their role's palette.

const ROLE_RANGES = {
  employee: [200, 240], // blue
  teamlead: [140, 165], // green
  manager:  [270, 295], // purple
  owner:    [25, 45],   // amber
};

export function roleHueRange(role) {
  return ROLE_RANGES[role] || ROLE_RANGES.employee;
}

/** Deterministic avatar background based on name + role. */
export function avatarBg(name = "", role = "employee") {
  const [min, max] = roleHueRange(role);
  const seed = [...name].reduce((a, c) => (a + c.charCodeAt(0)) % 1000, 0);
  const hue = min + (seed % (max - min + 1));
  return `hsl(${hue} 68% 55%)`;
}

/** Optional: a matching softer background for chips / badges. */
export function avatarSoftBg(role = "employee") {
  const [min, max] = roleHueRange(role);
  const hue = Math.round((min + max) / 2);
  return `hsl(${hue} 78% 92%)`;
}
